// Import jQuery
import $ from 'jquery';
// Import Isotope
import Isotope from 'isotope-layout';
// Import matchHeight
import 'jquery-match-height';

// Variables
var itemSelector = ".grid-item";
var $filterButtons = $('.filter-button');
var $container = $('.grid');

// Initialize Isotope
var iso = new Isotope($container[0], {
    itemSelector: itemSelector
});

function adjustCardHeights() {
    var $cards = $(itemSelector);

    // Alle bestehenden Höhen zurücksetzen
    $cards.css('height', 'auto');

    // MatchHeight aufrufen
    $cards.matchHeight({
        byRow: true,
        property: 'height'
    });

    // Isotope neu layouten
    if (Array.isArray(iso)) {
        iso.forEach(i => i.layout());
    } else if (iso && typeof iso.layout === 'function') {
        iso.layout();
    }
}

// Ascending order
var responsiveIsotope = [[480, 4], [720, 6]];
var itemsPerPageDefault = 6;
var itemsPerPage = defineItemsPerPage();
var currentNumberPages = 1;
var currentPage = 1;
var currentFilter = '*';
var filterAttribute = 'data-filter';
var filterValue = "";
var pageAttribute = 'data-page';
var pagerClass = 'isotope-pager';

// Update items based on current filters
function changeFilter(selector) {
    iso.arrange({ filter: selector }, () => {
        // Nach dem Filtern die Kartenhöhen angleichen
        adjustCardHeights();
    });
}

function updatePaginationButtons() {
    let sronly = document.querySelector('.curr-page');
    if (sronly) {
        sronly.remove();
    }

    var $paginationItems = $('.pagination .page-item');
    var $prev = $paginationItems.first();
    var $next = $paginationItems.last();

    $prev.off("click");
    if (currentPage <= 1) {
        $prev.addClass('disabled');
    } else {
        $prev.removeClass('disabled');
        $prev.on("click", function (e) {
            e.preventDefault();
            goToPage(currentPage - 1, true);
        });
    }

    $next.off("click");
    if (currentPage >= currentNumberPages) {
        $next.addClass('disabled');
    } else {
        $next.removeClass('disabled');
        $next.on("click", function (e) {
            e.preventDefault();
            goToPage(currentPage + 1, true);
        });
    }

    $paginationItems.removeClass('active');
    $paginationItems.each(function () {
        var $link = $(this).find('a');
        var pageText = $link.data('page');
        if (parseInt(pageText) === parseInt(currentPage)) {
            $(this).addClass('active');
            if ($link.find('.sr-only').length === 0) {
                $link.append('<span class="sr-only curr-page">Aktuelle Seite</span>');
            }
        }
    });
}

// Navigation
function goToPage(n, scroll = false) {
    currentPage = parseInt(n);
    filterValue = currentFilter;
    var wordPage = currentPage.toString();
    filterValue += ('.' + wordPage);
    changeFilter(filterValue);
    updatePaginationButtons();

    // Scroll to the first storytelling item
    if(scroll) {
        var $target = $('.storytelling-items').first();
        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top - 150
            }, 500); // 500ms für sanften Übergang
        }
    }
}

// Responsive Items Per Page
function defineItemsPerPage() {
    var pages = itemsPerPageDefault;
    for (var i = 0; i < responsiveIsotope.length; i++) {
        if ($(window).width() <= responsiveIsotope[i][0]) {
            pages = responsiveIsotope[i][1];
            break;
        }
    }
    return pages;
}

// Pagination Setup
function setPagination() {
    var SettingsPagesOnItems = function () {
        var itemsLength = $container.children(itemSelector).length;
        var pages = Math.ceil(itemsLength / itemsPerPage);
        var item = 1;
        var page = 1;

        filterValue = currentFilter;

        $container.children(filterValue).each(function () {
            if (item > itemsPerPage) {
                page++;
                item = 1;
            }

            var wordPage = page.toString();
            var classes = $(this).attr('class').split(' ');
            var lastClass = classes[classes.length - 1];

            if (lastClass.length < 4) {
                $(this).removeClass();
                classes.pop();
                classes.push(wordPage);
                classes = classes.join(' ');
                $(this).addClass(classes);
            } else {
                $(this).addClass(wordPage);
            }
            item++;
        });

        currentNumberPages = page;
        adjustCardHeights();
    }();

    var CreatePagers = function () {
        var $paginationContainer = $('.pagination');
        $paginationContainer.html('');

        if (currentNumberPages <= 1) {
            $paginationContainer.hide();
            return;
        } else {
            $paginationContainer.show();
        }

        var $prevPage = $('<li class="page-item"> <a class="page-link" href="#" data-page="-1" tabindex="-1" aria-disabled="true"> <span class="sr-only">Vorherige Seite</span> </a> </li>');
        if (currentPage <= 1) {
            $prevPage.addClass('disabled');
        } else {
            $prevPage.click(function (e) {
                e.preventDefault();
                goToPage(currentPage - 1);
            });
        }
        $paginationContainer.append($prevPage);

        for (var i = 1; i <= currentNumberPages; i++) {
            var $pageLink;
            if (i === currentPage) {
                $pageLink = $('<li class="page-item active"><a class="page-link" data-page="' + i + '" href="#">' + i + '<span class="sr-only curr-page">Aktuelle Seite</span></a></li>');
            } else {
                $pageLink = $('<li class="page-item"><a class="page-link" data-page="' + i + '" href="#">' + i + '</a></li>');
            }

            $pageLink.click(function (e) {
                e.preventDefault();
                var page = $(this).find('a').data('page');
                goToPage(page, true);
            });

            $paginationContainer.append($pageLink);
        }

        var $nextPage = $('<li class="page-item"> <a class="page-link" data-page="-1" href="#"> <span class="sr-only">Nächste Seite</span> </a> </li>');
        if (currentPage >= currentNumberPages) {
            $nextPage.addClass('disabled');
        } else {
            $nextPage.click(function (e) {
                e.preventDefault();
                goToPage(currentPage + 1, true);
            });
        }
        $paginationContainer.append($nextPage);
    }();
}

// Initialisierung
setPagination();
goToPage(1);

// Filter Buttons
$filterButtons.click(function () {
    var $this = $(this);
    var filterVal = $this.attr(filterAttribute);

    if (filterVal === '*') {
        $filterButtons.removeClass('is-checked');
        $this.addClass('is-checked');
    } else {
        if ($this.hasClass('is-checked')) {
            $this.removeClass('is-checked');
        } else {
            $filterButtons.filter('[' + filterAttribute + '="*"]').removeClass('is-checked');
            $this.addClass('is-checked');
        }
    }

    var selectedFilters = [];
    $filterButtons.each(function () {
        if ($(this).hasClass('is-checked')) {
            selectedFilters.push($(this).attr(filterAttribute));
        }
    });

    if (selectedFilters.length === 0) {
        $filterButtons.filter('[' + filterAttribute + '="*"]').addClass('is-checked');
        currentFilter = '*';
    } else {
        currentFilter = selectedFilters.join(',');
    }

    setPagination();
    goToPage(1);
    
    // Sicherheits-Update nach kurzer Verzögerung
    setTimeout(() => {
        triggerLayoutUpdate();
    }, 500);
});


function triggerLayoutUpdate() {
    itemsPerPage = defineItemsPerPage();
    setPagination();
    goToPage(1); 

    // Erstes Layout-Update mit Verzögerung
    setTimeout(() => {
        $.fn.matchHeight._update();
        iso.layout();
    }, 500); // <- verlängert von 300 auf 500ms

    // Sicherheitshalber ein zweites Update, falls das erste zu früh war
    setTimeout(() => {
        $.fn.matchHeight._update();
        iso.layout();
    }, 1000);
}

// Bei Fenstergröße neu berechnen
$(window).on('resize', function () {
    triggerLayoutUpdate();
});

// Bei Änderung der Ausrichtung (Smartphones/Tablets)
$(window).on('orientationchange', function () {
    triggerLayoutUpdate();
});

// Initialer Trigger
setTimeout(() => {
    triggerLayoutUpdate();
}, 700); // ebenfalls etwas verzögert